import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import HeaderLayout from '../../../../components/Layout/Header/HeaderLayout';
import SimulatorInvestmentFunds from '../../../../components/simulator/SimulatorInvestmentFunds';
import Spinner from '../../../../components/Spinner';
import ModalErrorFetch from '../../../../components/UI/ModalErrorFetch';
import { useCashBalance } from '../../../../context/CashBalanceContext';
import { InvestmentContext } from '../../../../context/InvestmentContext';
import useModal from '../../../../hooks/custom/useModal';
import useGetSimulatorList from '../../../../hooks/useGetSimulatorList';
import { useGetUserDividend } from '../../../../hooks/useGetUserDividend';
import { onRefresh } from '../../../../utils/refreshPage';
import { getFirstElement } from '../../../../utils/utils';

const FundsInvestment = () => {
  const { isShowing, toggle } = useModal();
  const user = useSelector(state => state.auth.user);
  const userRisk = user?.['custom:profile'] ? user['custom:profile'].toLowerCase() : '';
  const securitySelected = useSelector(state => state.simulation.securitySelected);

  const { id: simulationId } = useParams();

  const { formData } = useContext(InvestmentContext);

  const {
    balance: balanceData,
    loading: loadingBalance,
    error: errorBalance,
    refetch,
  } = useCashBalance();

  const {
    data: statusDividend,
    loading: loadingStatusDividend,
    error: errorStatusDividend,
  } = useGetUserDividend();

  const statusDividendFinfolio = statusDividend?.getUserDividendFinfolio?.Custom.find(item => {
    return item.Description === securitySelected?.ID?.toLowerCase();
  });

  const custom = JSON.parse(securitySelected.Custom);
  const motivations = getFirstElement(custom?.preferences.motivaciones);
  const interests = getFirstElement(custom?.preferences.intereses);
  const motivationsId = custom?.preferences.motivaciones[0].id;
  const risk = custom?.preferences.riesgo.description;
  const interestsId = custom?.preferences.intereses[0].id;

  const fileAs = {
    currency: custom.fund_details.currency,
    fileAs: 'FileAsName',
    fileAsComplete: securitySelected?.Name?.slice(4),
    risk: risk,
    motivation: motivations?.split('-')[0],
    motivationId: motivationsId,
    interests: interests,
    interestsId: interestsId,
    products: true,
    profit: securitySelected?.profit,
  };

  const fundProfileNames = {
    fundName: securitySelected?.Name,
    profileName: custom?.preferences?.riesgo?.description,
  };

  const dataChart = fundProfileNames;

  const { profileName } = dataChart;

  const fundName = securitySelected?.Name;

  const result = { fileAsComplete: fundName };
  const { fileAsComplete } = result;

  const userRiskCondition =
    profileName
      ?.replace(/\bCLP\b\s*/g, '')
      .trim()
      .toLowerCase() === userRisk;

  if (loadingStatusDividend) {
    return <Spinner />;
  }

  if (errorStatusDividend) {
    return (
      <ModalErrorFetch
        message='Lo sentimos, algo no salio bien acá....'
        error={errorStatusDividend}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }

  return (
    <>
      <HeaderLayout mode='funds' type='product' fileAs={fileAs} />
      <SimulatorInvestmentFunds
        balanceData={balanceData}
        fileAsComplete={fileAsComplete}
        loadingBalance={loadingBalance}
        errorBalance={errorBalance}
        refetch={refetch}
        formData={formData}
        profileName={profileName}
        userRiskCondition={userRiskCondition}
        userRisk={userRisk}
        statusDividendFinfolio={statusDividendFinfolio}
        securitySelected={securitySelected}
        simulationId={simulationId}
      />
    </>
  );
};

export default FundsInvestment;
